import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

open() {
  this.showDialog();

  // ✅ Trigger dataLayer cart_viewed event
  if (!window.__cartViewedFired) {
    window.__cartViewedFired = true;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const items = cart.items.map(item => ({
          item_id: item.variant_id,
          item_name: item.product_title,
          item_variant: item.variant_title,
          item_brand: item.vendor,
          item_category: item.product_type,
          quantity: item.quantity,
          price: item.final_price / 100
        }));

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "cart_viewed",
          cart_id: cart.token,
          cart_total: cart.total_price / 100,
          currency: Shopify.currency.active || "CAD",
          item_count: cart.item_count,
          items: items
        });

        console.log("✅ cart_viewed pushed to dataLayer");
      })
      .catch(err => console.error("❌ Failed to fetch cart:", err));
  }

  // Existing installments logic
  customElements.whenDefined('shopify-payment-terms').then(() => {
    const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
    const cta = installmentsContent?.querySelector('#shopify-installments-cta');
    cta?.addEventListener('click', this.closeDialog, { once: true });
  });
}


  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
